import { IOProps } from 'react-compose-io'
import { RegraTransformacaoApiForm } from './components/RegraTransformacaoApiForm'
import { RegraTransformacaoApiIO } from './RegraTransformacaoApi.IO'

export type RegraTransformacaoProps = {}

export function RegraTransformacaoApiView({ _io }: IOProps<RegraTransformacaoApiIO, RegraTransformacaoProps>) {
  function RegraTransformacaoEdicao() {
    return <>{_io.regraTransformacaoEditar ? <RegraTransformacaoApiForm regraTransformacaoEditar={_io.regraTransformacaoEditar} /> : null}</>
  }

  return _io.regraId ? RegraTransformacaoEdicao() : <RegraTransformacaoApiForm />
}
